(() => {
	angular
		.module('main')
		.directive('subscriptionInfoModal', subscriptionInfoModal);

	subscriptionInfoModal.$inject = [];

	function subscriptionInfoModal() {
		return {
			restrict: 'E',
			scope: {
				user: '=',
				currentPlan: '<',
				userLocal: '<',
				btnDisable: '<',
				remainingTime: '<',
				giveFreeMonths: '&'
			},
			template: `<div id="subscriptionModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <btn-close></btn-close>
                                        <h3 class="modal-title">Free Access</h3>
                                    </div>
                                    <div class="modal-body clearfix">
                                    	<div class="free-access-block">
											<div class="text-nowrap user-info-block">
												<h4>User: <span>{{user.userInfo.userName}}</span></h4>
												<div ng-show="!user.currentPlan" class="expired btn-danger">EXPIRED</div>									
											</div>
											<div class="text-nowrap user-info-block">
												<h4>Email: <span>{{user.userInfo.userEmail}}</span></h4>											
											</div>     
											<div class="text-nowrap user-info-block" ng-if="remainingTime"> 
												<h4>Remaining Free Period: <span>{{remainingTime}} left unused</span></h4>	
											</div>         
											<div ng-if="currentPlan" class="subscription-container admin-subscription mt-15">                       
												<div class="subscription--plan"> 
													<table class="subscription--plan__table">
														<tr ng-repeat="item in currentPlan track by $index" class="t-row">
															<td class="t-cell-title">{{ item }}</td>
															<td class="t-cell-info">{{ user.currentPlan.properties[item].description }}
																<div ng-show="subscriptionInfo.customerInfo.properties[item].prompt" class="t-cell-info-label">
																	<i aria-hidden="true" class="fa fa-info-circle"></i>
																	<span class="label label-general label-status label-response label-warning--triangle label-hover">{{ user.currentPlan.properties[item].prompt }}</span>
																</div>
															</td>
														</tr>
													</table>
												</div>
											</div>  
                                        </div>
                                        <hr class="mt-5">
                                        <div class="flex-row flex-just-space-around mt-15">
											<div class="styled-input-radio pl-30">
												<input type="radio" id="PRORATABLE" value="PRORATABLE" ng-model="freeAccessMethod">
												<label for="PRORATABLE">Free access for active paid subscribers</label>
											</div>
											<div class="styled-input-radio pl-30">
												<input type="radio" id="INSTANT" value="INSTANT" ng-model="freeAccessMethod">
												<label for="INSTANT">Free access for ambassadors, trial or expired users</label>
											</div>
										</div>
										
										<div class="flex-row mt-15 free-access-description">
											<span ng-if="freeAccessMethod === 'PRORATABLE'">This adds free days to an active paid subscriber’s account in the form of a discount on their next invoice. If their subscription plan changes, any unused free days are kept and applied to the next invoice.</span>
											<span ng-if="freeAccessMethod === 'INSTANT'">This adds free days to the account of an ambassador, trial or expired user by assigning or extending their free subscription. Avoid using this for active paid subscribers.</span>
										</div>
                                        
                                        <div class="mt-20">
                                            <div class="flex-row">
                                            	<div class="flex-1 mr-7">
													<input id="unitCount" placeholder="Put number of count" class="form-control" type="number"
														   step="any" ng-keypress="onKeypress($event)" ng-disabled="btnDisable"
														   ng-model="setTimeConfiguration.unitCount">
												</div>
												 <div class="flex-1">
													<select class="form-control"  ng-model="setTimeConfiguration.timeUnit" ng-disabled="btnDisable">
														<option value="DAY">Day</option>
														<option value="MONTH">Month</option>
													</select>
												</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="modal-footer modal-foot">
                                            <button class="btn btn-accept btn-lg" ng-disabled="btnDisable" 
                                            		ng-click="giveFreeMonths({setTimeConfiguration, userLocal, freeAccessMethod})"
                                                    spinning-wheel is-spinning-wheel-active="btnDisable">
                                                Give free access
                                            </button>
                                            <button class="btn btn-default btn-lg" ng-disabled="btn_disable" data-dismiss="modal">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `,
			replace: true,
			transclude: true,
			link(scope, element) {
				scope.setTimeConfiguration = {
					timeUnit: 'MONTH',
					unitCount: null
				};
				scope.freeAccessMethod = 'PRORATABLE';

				element.on('keypress', event => {
					if (
						event.key === 'e' ||
						event.key === '+' ||
						event.key === '-' ||
						event.key === '.'
					) {
						event.preventDefault();
					}
				});
				$('#subscriptionModal').on('hidden.bs.modal', () => {
					scope.setTimeConfiguration = {
						timeUnit: 'MONTH',
						unitCount: null
					};
					scope.freeAccessMethod = 'PRORATABLE';
				});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/admin/adminSubscriptionModal.js